<template>
  <el-card shadow="nerver">
    <!-- 添加poi -->
    <div style="display:flex">
      <div>
        <el-button @click="$router.push({ name: 'check_list_add' })"
                   size="mini"
                   type="primary"
                   icon="el-icon-plus"
                   plain>新建清单</el-button>
      </div>

    </div>
    <!-- 列表 -->
    <div>
      <el-table :data="check_list"
                style="width: 100%">
        <el-table-column prop="id"
                         label="清单id"
                         width="70">
        </el-table-column>
        <el-table-column prop="list_name"
                         label="清单名称"
                         width="240">
        </el-table-column>
        <el-table-column prop="list_remark"
                         label="清单说明"
                         width="">
        </el-table-column>

      </el-table>

    </div>
  </el-card>
</template>

<script>
import SelectDest from '../../components/common/select/SelectDest'

export default {
  name: 'check-list',
  components: {
    SelectDest,
  },
  data() {
    return {
      dialogVisible: false,
      check_list: [],
      destShowBack: 15,
      dest: 15,
      addLatLngPoiId: null,
    }
  },
  mounted() {
    this.getCheckList()
  },
  methods: {
    getCheckList() {
      this.$http.get(`/traver/get_check_list`).then((res) => {
        if (res.data.errno == '0') {
          this.check_list = res.data.data
        } else {
          this.$message({
            type: 'error',
            message: res.data.errmsg,
          })
        }
      })
    },
  },
}
</script>

<style>
</style>